import React from "react";
import { NavLink, Link } from "react-router-dom";

import GlobalData from "../context/globaldata";

import { ReactComponent as IconDashboard } from "../images/icons/dashboard.svg";
import { ReactComponent as IconBrews } from "../images/icons/brews.svg";
import { ReactComponent as IconSignout } from "../images/icons/signout.svg";
import { ReactComponent as Logo } from "../images/logo.svg";

class Sidebar extends React.Component {
  static contextType = GlobalData;

  state = {
    dropdown: false,
    brewsFilter: ""
  }

  toggleDropdown = () => {
    this.setState({
      dropdown: !this.state.dropdown
    })
  }

  applyFilter(filter) {
    this.context.setBrewsFilter(filter);
  }

  componentDidUpdate(prevProps, prevState) {

    if(prevState.brewsFilter !== this.context.brewsFilter) {
      this.setState({
        brewsFilter: this.context.brewsFilter
      })
    }
  }

  render() {

    if (this.context.userSettings && this.props.firebaseAuth.currentUser) {
      return (
        <aside className={`sidebar sidebar--primary ${this.context.minifiedSidebar ? 'is-collapsed' : '' }`}>
          {/* <Scrollbar noScrollX={true}> */}
            <div className="sidebar__container">
              <div className="sidebar__top">
                <Logo />
                <h1 className="sidebar__logo">Coffee Journal</h1>
              </div>
              <nav className="navigation navigation--primary">
                <ul className="navigation__list">
                  <li className="navigation__item navigation__item--primary">
                    <NavLink exact={true} className="navigation__anchor navigation__anchor--primary" activeClassName='is-active' to='/'>
                      <IconDashboard />
                      <span>Dashboard</span>
                    </NavLink>
                  </li>
                  <li className="navigation__item navigation__item--primary">
                    <NavLink className="navigation__anchor navigation__anchor--primary" activeClassName='is-active' to='/brews' onClick={ () => { this.applyFilter('') } }>
                      <IconBrews />
                      <span>Brews</span>
                      <span className="sidebar__counter">{ this.context.brewAmountTotal }</span>
                    </NavLink>
                    <ul className="navigation__sub-list">
                      <li className="navigation__sub-item">
                        <NavLink className={`navigation__anchor navigation__anchor--secondary ${this.state.brewsFilter === '' ? 'is-active' : '' }`} to='/brews' activeClassName='' onClick={ () => { this.applyFilter('') } }>
                          <i className="material-icons">all_inclusive</i>
                          <span>All brews</span>
                        </NavLink>
                      </li>
                      <li className="navigation__sub-item" >
                        <NavLink className={`navigation__anchor navigation__anchor--secondary ${this.state.brewsFilter === 'favorite' ? 'is-active' : '' }`} to='/brews' activeClassName='' onClick={ () => { this.applyFilter('favorite') } }>
                          <i className="material-icons">favorite</i>
                          <span>Favorite brews</span>
                        </NavLink>
                      </li>
                      <li className="navigation__sub-item" >
                        <NavLink className={`navigation__anchor navigation__anchor--secondary ${this.state.brewsFilter === 'trashed' ? 'is-active' : '' }`} to='/brews' activeClassName='' onClick={ () => { this.applyFilter('trashed') } }>
                          <i className="material-icons">delete</i>
                          <span>Trashed brews</span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
              <button className="button button--toggle-sidebar" onClick={ this.context.toggleSidebarSize }>
                <span>Minify sidebar</span>
              </button>
              { !this.context.userSettings.premium_user &&
                <div className="sidebar__meta">
                  <span>Free plan</span>
                  <span className="sidebar__counter">{ this.context.brewAmountTotal } / 50</span>
                </div>
              }
              <div className="sidebar__footer">
                <div className="sidebar__user">
                  <img src={ this.props.firebaseAuth.currentUser.photoURL } alt=""/>
                  <span className="sidebar__name">{ this.props.firebaseAuth.currentUser.displayName }</span>
                </div>
                <button className="sidebar__dropdown-toggle" onClick={ this.toggleDropdown }>
                  <i className="material-icons">more_vert</i>
                </button>
                <div className={`sidebar__dropdown ${this.state.dropdown ? 'is-visible' : '' }`}>
                  <Link className="button button--sidebar" to='/user/' onClick={ this.toggleDropdown }>
                    <span>Settings</span>
                    <i className="material-icons">settings</i>
                  </Link>
                  <button className="button button--sidebar" onClick={ () => { this.props.firebaseAuth.signOut() } }>
                    <span>Log out</span>
                    <IconSignout />
                  </button>
                </div>
              </div>
            </div>
          {/* </Scrollbar> */}
        </aside>
      )
    } else {
      return null
    }
  }
}

export default Sidebar;
